module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-triangles-red-9a45ff0245da1d266c8c99da2a21f103.svg";